import * as React from 'react';

import ChatIcon from '@mui/icons-material/Chat';
import { Chip } from '@mui/material';

export const UnsupportedChip = ({server}: {server: boolean}) => {

    return <Chip color='default' label={server?"not supported by server":"not supported by client"} icon={<ChatIcon />}/>
}